// extracted by mini-css-extract-plugin
export default {"button":"LandscapeUpdatesTemplate_button__TeNfS"};